import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { MarkdownComponent } from "ngx-markdown";
import { cn } from "pax-ui/core";

@Component({
  selector: "pax-markdown",
  standalone: true,
  imports: [CommonModule, MarkdownComponent],
  templateUrl: "./markdown.html",
  styleUrls: ["./markdown.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Markdown {
  @Input() class: string = "";

  get getMarkdownStyles() {
    return cn("prose", this.class);
  }
}
